import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
/**
 * 视频
 */
var Video = function Video(props, ref) {
  return /*#__PURE__*/React.createElement("video", _extends({}, props, {
    ref: ref
  }));
};
var RefVideo = /*#__PURE__*/React.forwardRef(Video);
RefVideo.defaultProps = {
  src: 'https://fusion.alicdn.com/fusion-site-2.0/fusion.mp4'
};
export default RefVideo;